module.exports = __webpack_public_path__ + "img/registerGreen.0b2d84f6.jpg";